<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <material-card
          color="primary"
          title="Ingresar pedido"
          text>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4>
                  <v-text-field label="Tipo de documento"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    class="purple-input"
                    label="Documento"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    label="Nombre"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-text-field
                    label="Fecha de entrega"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6>
                  <v-text-field
                    label="Franja horario"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md12>
                  <v-text-field
                    label="Dirección de entrega"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    label="Departamento"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    label="Municipio"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    class="Orden"
                    label="Postal Code"
                    type="number"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex md12>
        <material-card color="primary">
          <v-data-table
            :rows-per-page-text="$t('rows-per-page-text')"
            :rows-per-page-items="globalrowsPerPageItems"
            :no-data-text="$t('no-data-available')"
            :headers="headers"
            :items="items"
            hide-actions>
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-primary"
                v-text="header.text"/>
            </template>
            <template
              slot="items"
              slot-scope="{ item }">
              <td>{{ item.name }}</td>
              <td>{{ item.country }}</td>
              <td>{{ item.city }}</td>
              <td class="text-xs-right">{{ item.salary }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-btn
        round
        color="secondary">
        <v-icon
          dark
          left>mdi-upload</v-icon>Generar pedido
      </v-btn>
      <v-flex md12/>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    headers: [
      {
        sortable: false,
        text: 'Orden',
        value: 'name'
      },
      {
        sortable: false,
        text: 'PLU',
        value: 'country'
      },
      {
        sortable: false,
        text: 'Descripción',
        value: 'city'
      },
      {
        sortable: false,
        text: 'Cantidad',
        value: 'salary',
        align: 'right'
      }
    ],
    items: [
      {
        name: '0001',
        country: '0001',
        city: 'Oud-Tunrhout',
        salary: '12'
      },
      {
        name: '0002',
        country: '0001',
        city: 'Sinaai-Waas',
        salary: '23'
      },
      {
        name: '0003',
        country: '0001',
        city: 'Overland Park',
        salary: '56'
      },
      {
        name: '0004',
        country: '0001',
        city: 'Gloucester',
        salary: '38'
      },
      {
        name: '0005',
        country: '0001',
        city: 'Feldkirchen in Kārnten',
        salary: '63'
      },
      {
        name: '0006',
        country: '0001',
        city: 'Gloucester',
        salary: '78'
      }
    ]
  })
}
</script>

<style lang="css" scoped>
table thead {
  background-color: black !important;
}
</style>
